/*
 *
 * Agent constants
 *
 */

export const DEFAULT_ACTION = 'app/Agent/DEFAULT_ACTION';
